const Zh = {
  '工作站': '工作站'
}
export default Zh



// WEBPACK FOOTER //
// ./src/lang/zh.js